/*
|--------------------------------------------------------------------------
| Views: Grid Infinite 1
|--------------------------------------------------------------------------
*/

/**
 * Grid Infinite
 * @namespace
 */
__gh__webApp.views.gridInfinite1 = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.infiniteScroll.init();
	},

	"getSubView": function(bucket){
		// Prep Items
		bucket.view.name 				= "buckets/gridInfinite1/default";
		bucket.view.infiniteScroll.view	= "buckets/gridInfinite1/partials/_infinite";
		return bucket;

	}

};